import * as React from 'react'
import { forwardRef } from 'react'

/**
 * Canvas component for displaying the base image.
 * Renders as an absolute positioned canvas that maintains aspect ratio.
 */
export const ImageCanvas = forwardRef<HTMLCanvasElement>((_, ref) => {
	return (
		<canvas
			ref={ref}
			style={{
				position: 'absolute',
				maxWidth: '100%',
				maxHeight: '100%',
				width: 'auto',
				height: 'auto',
			}}
		/>
	)
})

ImageCanvas.displayName = 'ImageCanvas'
